// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, browserPopupRedirectResolver } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
apiKey: "AIzaSyBmanXLK_YCRV6ABc0J2JVDjUdYyLTMrMc",
authDomain: "peacetech-web.firebaseapp.com",
projectId: "peacetech-web",
storageBucket: "peacetech-web.firebasestorage.app",
messagingSenderId: "269406196680",
appId: "1:269406196680:web:0b7d851715149292e7a6fd",
measurementId: "G-VPYHHB0LQ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Let Firebase restore sign-in after reloads and Stripe redirects. It selects
// the first available storage; signOut clears the SDK-managed session.
const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});

export { app, auth, analytics };
